var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wcc confirmation"},[_c('h2',[_c('font-awesome-icon',{attrs:{"icon":['fa', 'check']}}),_vm._v("Email Sent")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }